<template>
  <div class="v-content">
    <div class="title">基本信息</div>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
      <FormItem label="所属分类" prop="classify_id">
        <Select placeholder="请选择" v-model="formValidate.classify_id" style="width:200px" clearable>
          <Option v-for="item in classify" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="资讯标题" prop="title">
        <Input v-model="formValidate.title" placeholder="请输入" style="width: 300px;" clearable />
      </FormItem>
      <FormItem label="资讯来源" prop="from" v-if="false">
        <Input v-model="formValidate.from" placeholder="请输入" style="width: 300px;" clearable />
      </FormItem>
      <FormItem label="资讯封面" prop="thumb_img">
        <div style="display:flex;align-items:center;">
          <div v-show="formValidate.thumb_img" class="news-cover">
            <img :src="formValidate.thumb_img" alt />
            <Input v-model="formValidate.thumb_img" style="display:none" clearable />
          </div>
          <Upload
            :action="baseUrl+'/api/public/img'"
            :show-upload-list="false"
            :headers="header"
            :on-success="successHanlder"
            :format="['jpg','jpeg','png']"
          >
            <Button icon="ios-cloud-upload-outline">选择文件</Button>
            <p class="sm-title">435*255像素或1.7:1，支持jpg、jpeg、png,小于5M</p>
          </Upload>
        </div>
      </FormItem>
      <FormItem label="资讯摘要" prop="description">
        <Input v-model="formValidate.description" type="textarea" placeholder="请输入" clearable />
      </FormItem>
      <FormItem label="资讯详情" prop="content">
        <UEditor v-model="formValidate.content"></UEditor>
      </FormItem>
    </Form>
    <div class="submit">
      <Button size="large" @click="goBack">返回</Button>
      <Button size="large" @click="preview">预览</Button>
      <Button @click="saveCourse" size="large" type="primary">保存并返回</Button>
    </div>
    <Modal v-model="showPreviewModal" title="预览" width="1200px">
      <div class="news-main">
        <div class="news-title">{{formValidate.title}}</div>
        <div>
          <span class="news-click">{{click_rate}}浏览</span>
          <span
            class="news-time"
            v-if="created_at"
          >{{new Date(created_at*100).format("yyyy-MM-dd hh:mm")}}</span>
          <span class="news-time" v-else>{{new Date().format("yyyy-MM-dd hh:mm")}}</span>
        </div>
        <div class="news-content" v-html="formValidate.content"></div>
      </div>
      <template v-slot:footer>
        <Button type="primary" @click="showPreviewModal=false">确定</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import UEditor from "@/components/UEditor.vue";
const buildConfig = require("../../../build/" + process.env.BUILD_ENV + ".js");
export default {
  name: "NewsEdit",
  components: {
    UEditor
  },
  data() {
    return {
      id: this.$route.query.id || "",
      baseUrl: buildConfig.BASE_URL,
      classify: [],
      header: {
        Authorization: "Bearer " + localStorage.adminToken
      },
      formValidate: {
        classify_id: "",
        title: "",
        from: "",
        thumb_img: "",
        description: "",
        content: ""
      },
      ruleValidate: {
        classify_id: [
          {
            required: true,
            message: "请选择"
          }
        ],
        title: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          }
        ],
        description: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          }
        ],
        thumb_img: [
          { required: true, message: "请上传封面！", trigger: "change" }
        ],
        content: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          }
        ]
      },
      showPreviewModal: false,
      click_rate: 0,
      created_at: 0
    };
  },
  created() {
    this.getCourseInfo();
    this.getClassify();
  },
  methods: {
    // 返回
    goBack() {
      this.$router.push({
        name: "NewsManage"
      });
    },
    // 详情
    getCourseInfo() {
      if (this.id) {
        this.$http.get(`/api/information/${this.$route.query.id}`).then(res => {
          this.formValidate = res;
          this.created_at = res.created_at;
          this.click_rate = res.click_rate;
        });
      }
    },
    // 分类
    getClassify() {
      this.$http.get(`/api/informationClassify`).then(res => {
        this.classify = res;
      });
    },
    successHanlder(response) {
      this.formValidate.thumb_img = response.data.path;
    },
    saveCourse() {
      this.$refs["formValidate"].validate(valid => {
        if (valid) {
          if (this.id) {
            this.$http
              .put(`/api/information/${this.id}`, this.formValidate)
              .then(() => {
                this.goBack();
              });
          } else {
            this.$http.post("/api/information", this.formValidate).then(() => {
              this.goBack();
            });
          }
        } else {
          this.$Message.error("您有未填项!");
        }
      });
    },
    preview() {
      this.showPreviewModal = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-content {
  text-align: left;
  font-size: 16px !important;
  padding: 15px;
  background: #fff;
}
.title {
  position: relative;
  margin-bottom: 20px;
  padding: 5px 15px;
}
.title::before {
  display: block;
  position: absolute;
  left: 0;
  top: 7px;
  content: "";
  height: 20px;
  background-color: #2d8cf0;
  width: 4px;
}
.news-cover {
  width: 144px;
  height: 81px;
  display: inline-block;
  margin-right: 30px !important;
}
.news-cover img {
  width: 144px;
  height: 81px;
  padding: 0;
  margin: 0;
  border: 1px solid #dcdee2;
}
.sm-title {
  color: #ccc;
  font-size: 12px;
}
.submit {
  text-align: center;
  button {
    margin: 0 20px;
  }
}
.news-main {
  background-color: #fff;
  padding: 30px;
  margin-bottom: 50px;
}
.news-title {
  font-size: 20px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 8px;
}
.news-click,
.news-time {
  font-size: 16px;
  color: #8c8c8c;
  margin-right: 10px;
}
.news-content {
  padding-top: 25px;
  font-size: 14px;
}
</style>
